<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home/pos-list"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ pos()?.title }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (isLoading()) {
    <div class="loading-state">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  } @else if (pos(); as p) {

    @if (p.photos?.[0]?.url) {
      <div class="hero-photo">
        <ion-img [src]="p.photos![0].url"></ion-img>
      </div>
    }

    <div class="content-wrapper">

      @if (p.description) {
        <p class="description">{{ p.description }}</p>
      }

      @if (p.categories?.length) {
        <div class="categories">
          @for (cat of p.categories!; track cat.id) {
            <ion-chip>{{ cat.title }}</ion-chip>
          }
        </div>
      }

      @if (p.addresses || distance()) {
        <div class="location-row">
          <ion-icon name="location-outline"></ion-icon>
          <span>
            @if (distance(); as d) {
              <span class="distance">
                {{ d < 1 ? (d * 1000 | number:'1.0-0') + ' м · ' : (d | number:'1.1-1') + ' км · ' }}
              </span>
            }
            {{ p.addresses }}
          </span>
        </div>
      }

      @if (p.latitude && p.longitude) {
        <ion-button expand="block" fill="outline" (click)="openInMaps()">
          <ion-icon slot="start" name="navigate-outline"></ion-icon>
          {{ 'app#city_card#pos_detail#show_on_map' | translate }}
        </ion-button>
      }

      @if (p.phones?.length) {
        <div class="section">
          <h3>{{ 'app#city_card#pos_detail#contacts' | translate }}</h3>
          <ion-list lines="none" class="phone-list">
            @for (phone of p.phones!; track phone.number) {
              <ion-item button (click)="makeCall(phone.number!)">
                <ion-icon slot="start" name="call-outline"></ion-icon>
                <ion-label>{{ phone.number }}</ion-label>
              </ion-item>
            }
          </ion-list>
        </div>
      }

      @if (p.public_description && p.public_description !== p.description) {
        <div class="section">
          <p>{{ p.public_description }}</p>
        </div>
      }

      <div class="social-links">
        @for (key of socialLinks; track key) {
          @if (getSocialUrl(key); as url) {
            <ion-button fill="clear" (click)="openBrowser(url)">
              <ion-icon slot="icon-only" [name]="socialIcons[key]"></ion-icon>
            </ion-button>
          }
        }
      </div>

      @if (branches().length) {
        <div class="section">
          <h3>{{ 'app#city_card#pos_detail#other_branches' | translate }}</h3>
          <ion-list lines="full">
            @for (branch of branches(); track branch.id) {
              <ion-item button detail (click)="goToBranch(branch.id!)">
                <ion-label>
                  <h2>{{ branch.title }}</h2>
                  @if (branch.addresses) {
                    <p>{{ branch.addresses }}</p>
                  }
                </ion-label>
                @if (getBranchDistance(branch); as d) {
                  <ion-note slot="end">
                    {{ d < 1 ? (d * 1000 | number:'1.0-0') + ' м' : (d | number:'1.1-1') + ' км' }}
                  </ion-note>
                }
              </ion-item>
            }
          </ion-list>
        </div>
      }

    </div>
  }
</ion-content>
